module.exports = __webpack_public_path__ + "img/arch_icon4.4dbe5171.png";